<div class="navbar fixed-top navbar-expand-md">
    <!-- LOGO -->
    <a class="navbar-brand" [ngClass]="{ 'navbar-brand-override': disableMobileMenu }" href="#"><img [src]="brandImage"
            [alt]="brandImageAlt" width="158"></a>
    <!-- BOTON MENU MOBILE -->
     @if (!disableMobileMenu) {
      <button class="navbar-toggler" type="button" (click)="showMobileMenu = true">
        <i class="material-icons">menu</i>
      </button>
     }

    <ng-content select="[menuSection]"></ng-content>
    <div class="profile">
        <div class="profile-info">
            <ng-content select="[userActions]"></ng-content>
        </div>
        <user-info [enableImpersonation]="enableImpersonation"></user-info>
    </div>
</div>
<div class="navbar-mobile" [ngClass]="{ 'show': showMobileMenu }">
    <div class="navbar-mobile-header">
        <div class="logo">
            <img src="../../../assets/common/header/logo-randstad-white.png" alt="Randstad" width="126">
        </div>
        <div class="btn-close" (click)="showMobileMenu = false">
            <i class="material-icons">close</i>
        </div>
    </div>
    <ng-content select="[mobileMenuSection]"></ng-content>
</div>
